import { Model, modelRegistry } from './Model';
import { Sector, Order } from '../models';
export class Table extends Model {
    static entity = 'tables';
    id = null;
    name = null;
    type = 'regular';
    color = null;
    height = null;
    width = null;
    shape = null;
    pos_left = null;
    pos_top = null;
    sector_id = null;
    zone_id = null;
    beach_row_id = null;
    online_booking_enabled = false;
    price_override = null;
    created_at = null;
    updated_at = null;
    orders = [];
    sector;
    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null),
            type: this.attr('regular'),
            color: this.attr(null),
            height: this.attr(null),
            width: this.attr(null),
            shape: this.attr(null),
            pos_left: this.attr(null),
            pos_top: this.attr(null),
            sector_id: this.attr(null),
            zone_id: this.attr(null),
            beach_row_id: this.attr(null),
            online_booking_enabled: this.attr(false),
            price_override: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            sector: this.attr(undefined, value => value ? new Sector(value) : undefined),
            orders: this.attr([], (value) => (value || []).map(item => new Order(item))),
        };
    }
    constructor(record) {
        super();
        this.$fill(record);
    }
    /**
     * Make a copy of the table.
     */
    $duplicate() {
        return new Table(this.$toJson());
    }
    getSector() {
        return Sector.find(this.sector_id);
    }
    /**
     * True when the venue has at least one limited table. Limited tables are
     * what produce the "transfered" (Preuzeto) cash stat; when none exist that
     * stat is always zero, so its label/amount should be hidden everywhere.
     */
    static hasLimited() {
        return Table.all().some(t => t.type === 'limited');
    }
}
export default Table;
modelRegistry.register('Table', Table);
//# sourceMappingURL=Table.js.map